import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

// render - login
const UserLogin = Loadable(lazy(() => import("pages/Auth/User/UserLoginPage")));

// ==============================|| AUTH ROUTES ||============================== //

const LoginRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: <UserLogin />,
    },
  ],
};

export default LoginRoutes;
